import {
    getAssignedSalesManagers,
    ZohoUserAssignmentPageKey,
} from '@internal/services/TSalesManager';
import { TLocale } from '@internal/utils/machine/i18n/Locale';
import { SalesManagerContext } from '@internal/utils/SalesManager/SalesManagerContext';
import { useMediaQuery } from '@renderer-ui-library/mui/utils/mediaQuery/useMediaQuery';
import React, { useContext, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { MachineDetailsContactButtons } from './MachineDetailsContactButtons';
import { MachineDetailsContactInfo } from './MachineDetailsContactInfo';
import styles from './machineDetailsContact.module.scss';

interface Props {
    machineGroupId: string;
    locale: TLocale;
}

export const MachineDetailsContact: React.FC<Props> = React.memo(
    ({ machineGroupId, locale }) => {
        const { isMobile } = useMediaQuery();
        const { salesManagers: allSalesManagers } =
            useContext(SalesManagerContext);

        const salesManagers = useMemo(
            () =>
                getAssignedSalesManagers(
                    allSalesManagers,
                    ZohoUserAssignmentPageKey.ProductDetails,
                ),
            [allSalesManagers],
        );

        if (salesManagers.length === 0) {
            return null;
        }

        return (
            <>
                {!isMobile ? (
                    <MachineDetailsContactInfo
                        salesManagers={salesManagers}
                        machineGroupId={machineGroupId}
                        locale={locale}
                    />
                ) : (
                    <>
                        <MachineDetailsContactButtons
                            isMobile
                            contact={salesManagers[0]}
                            machineGroupId={machineGroupId}
                            locale={locale}
                        />
                        {createPortal(
                            <div className={styles.mobilButtonsOverlay} />,
                            document.body,
                        )}
                    </>
                )}
            </>
        );
    },
);

MachineDetailsContact.displayName = 'MachineDetailsContact';
